import { ICacheService } from '@/services/iCacheService';
import { LocalCacheService } from '@/services/impl/localCacheService';
import { IHttpService } from '@/services/iHttpService';
import { AxiosHttpService } from '@/services/impl/axiosHttpService';
import { IRequestService } from '@/services/iRequestService';
import { RequestService } from '@/services/impl/requestService';
import { IPartnerService } from '@/services/iPartnerService';
import { PartnerService } from '@/services/impl/partnerService';
import { IFileService } from '@/services/iFileService';
import { FileService } from '@/services/impl/fileService';

/**
 * @author <Aniket.P>
 * @description Object Factory
 * @copyright Supra International, inc
 */
export class ObjectFactory {


    public static getCacheService(): ICacheService {
        if (!this.iCacheService) {
            this.iCacheService = new LocalCacheService();
        }
        return this.iCacheService;
    }

    public static getHttpService(): IHttpService {
        if (!this.iHttpService) {
            this.iHttpService = new AxiosHttpService();
        }
        return this.iHttpService;
    }

    public static getRequestService(): IRequestService {
        if (!this.iRequestService) {
            this.iRequestService = new RequestService();
        }
        return this.iRequestService;
    }

    public static getPartnerService(): IPartnerService {
        if (!this.iPartnerService) {
            this.iPartnerService = new PartnerService();
        }
        return this.iPartnerService;
    }

    public static getFileService(): IFileService {
        if (!this.iFileService) {
            this.iFileService = new FileService();
        }
        return this.iFileService;
    }

    private static iCacheService: ICacheService;
    private static iHttpService: IHttpService;
    private static iRequestService: IRequestService;
    private static iPartnerService: IPartnerService;
    private static iFileService: IFileService;
}
